import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { formatDay } from '../streamingFormat';
import { streamingMessages as messages } from '../streamingMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from '../Streaming.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface StreamingPeriodDatesProps {
  range: { from: string; to: string };
  previousRange: { from: string; to: string } | null;
}

/** The dates under the picker: "Sep 5 – Oct 2 · against Aug 8 – Sep 4" (design b1). */
const StreamingPeriodDatesComponent: React.FC<StreamingPeriodDatesProps> = ({ range, previousRange }) => {
  const intl = useIntl();
  const start = formatDay(intl, range.from);
  const end = formatDay(intl, range.to);
  return (
    <div className={styles.periodDates}>
      {previousRange === null
        ? intl.formatMessage(messages.periodDatesNoPrevious, { start, end })
        : intl.formatMessage(messages.periodDates, {
            start,
            end,
            prevStart: formatDay(intl, previousRange.from),
            prevEnd: formatDay(intl, previousRange.to),
          })}
    </div>
  );
};

export const StreamingPeriodDates = TypedMemo(StreamingPeriodDatesComponent);
